module.exports = __webpack_public_path__ + "static/media/hunters_vest.4dcb9988.png";